import React from 'react';
import classNames from 'classnames';
import {
  nativoAdManager,
  NativoAdPlacementType,
  nativoAdWrapperClassnames,
  nativoAdPlaceholderHeightMap,
} from '@benzinga/ads-utils';
import { useWindowLoad } from '@benzinga/hooks';
import { useNativoAdImpression } from '../../hooks/useNativoAdImpression';

export interface NativoAdPlaceholderProps {
  className?: string;
  type: NativoAdPlacementType;
}

export const NativoAdPlaceholder: React.FC<NativoAdPlaceholderProps> = ({ className, type }) => {
  const adPlacementClassName = nativoAdWrapperClassnames[type || ''];
  const adPlaceholderHeight = nativoAdPlaceholderHeightMap[type || ''];

  const { containerRef } = useNativoAdImpression({
    placeholderClassName: adPlacementClassName,
    placementType: type,
  });

  useWindowLoad(() => {
    nativoAdManager.init(true);
  }, []);

  return <div className={classNames(adPlacementClassName, adPlaceholderHeight, className)} ref={containerRef} />;
};
